<script setup>
import { computed, inject } from 'vue';
import ConfigurationRadioSelectionV4 from '../ConfigurationRadioSelectionV4';
import { useMainStore } from '../../store/index.js';

import '../../styles/configurator-section.css';

const i18n = inject('i18n');

const store = useMainStore();

const emit = defineEmits(['select']);

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  optionsContainerStyle: {
    type: Object,
    default: () => {},
  },
});

const engines = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'engineType');
});

const specType = computed(() => {
  return store.misc?.specType?.trim()?.toLowerCase();
});
</script>

<template>
  <section
    v-if="props.items"
    id="powertrain"
    class="configurator-section"
  >
    <h2>{{ $i18n('drivelineHeaderTitle') }}</h2>
    <ConfigurationRadioSelectionV4
      v-if="engines"
      v-model="store.selected.driveline[engines.id]"
      :type="engines.id"
      :options="engines.options"
      :options-container-style="optionsContainerStyle"
      @select="emit('select', $event)"
    />
  </section>
</template>

<style scoped>
  @media only screen and (max-width: 1000px) {
    .configurator-section__row {
      flex-direction: column;
    }
  }
</style>
